<template>
    <div class="nature-content-box">
        <div class="nature-content-title title1">性格解析</div>
        <div v-if="natureCharacterData.needpay == 0" class="nature-content-main">
            <p v-if="natureCharacterData.characterData && natureCharacterData.characterData.waizai" class="nature-c-paragraph">
                <span class="nature-c-title green">外在性格</span>：
                {{natureCharacterData.characterData.waizai}}
            </p>
            <p v-if="natureCharacterData.characterData && natureCharacterData.characterData.neizai" class="nature-c-paragraph">
                <span class="nature-c-title yellow">内在性格</span>：
                {{natureCharacterData.characterData.neizai}}
            </p>
        </div>
        <div v-if="natureCharacterData.needpay == 0 && natureCharacterData.characterData && natureCharacterData.characterData.total.length > 0" class="nature-content-supply">
            <p v-for="cText in natureCharacterData.characterData.total" class="nature-c-paragraph">{{cText}}</p>
        </div>
        <div v-if="natureCharacterData.needpay == 1" class="nature-content-needpay1">
            <div class="nature-content-pp">
                <p>外露性格分析</p>
                <p>内在心理活动特点分析</p>
            </div>
            <nature-button 
                v-bind:buttonType="'2'"
                v-bind:productData="natureCharacterData.product"
                v-bind:discount="natureTimeLimit != 0"
                v-bind:clickFunc="clickPay">
            </nature-button>
        </div>
        <div v-if="natureTalentData.needpay == 0 || (natureCharacterData.needpay == 1 && natureTalentData.needpay == 1)" class="nature-content-box-joint"><span class="joint-l"></span><span class="joint-r"></span></div>
    </div>
</template>

<script>
import { CONFIG } from '../../modules/config';
import { MIX } from '../../modules/utils';
import NatureButton from './NatureButton.vue'
export default {
    name: 'NatureCharacter',
    components: { NatureButton },
    computed: {
        natureTalentData() {
            return this.$store.state.report.natureTalentData;
        },
        natureCharacterData() {
            return this.$store.state.report.natureCharacterData;
        },
        natureTimeLimit() {
            return this.$store.state.report.natureTimeLimit;
        }
    },
    methods: {
        clickPay(params) {
            MIX.trackButtonClicked('talent_unlock_character');
            var me = this,
                curSecond = this.$store.state.report.natureTimeLimit,
                detailInfo = this.$store.state.detail.personInfo;
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: params.data.pid,              //支付项目id
                    ptype: params.data.payType[2],     //支付方式
                    ext: detailInfo.id,                //支付的评测id
                    discount: curSecond > 0 ? CONFIG.character_discount : 1  //支付折扣
                },
                mixParams: {
                    pid: params.data.pid,
                    product_name: params.data.title,
                    price: params.data.price,
                    from: 'nature',
                },
                sucCb: function() {
                    console.log('支付成功，更新测评报告数据');
                    // 更新测验报告数据
                    if(detailInfo) {
                        me.$store.dispatch('report/getAiCharacter', {
                            detailInfo: detailInfo
                        });
                    }
                    // 更新ai状态
                    // me.$store.state.detail.personInfo.ai = 1;
                    // me.$store.dispatch('record/updateRecordListAIStatus', {
                    //     id: detailInfo.id
                    // });
                    // 支付成功
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                },
                failCb: function() {
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            });
        }
    }
}
</script>